<template>
  <div class="about">
    <!-- <div class="aboutComcontainer crumbs">
      <router-link to="/">Home</router-link> &gt; About EZFM
    </div> -->
    <!-- -- -->
    <div class="aboutComcontainer about-wrap">
      <h3>About EZFM</h3>
      <p>
        轻松调频EZFM是中国国际广播电台（CRI）开办的中英双语广播频率，是中国唯一中央级双语电台，也是中国最早开办和最受欢迎的双语电台，每天24小时播出国内外新闻资讯、欧美及华语音乐精品、跨文化交流和学知栏目等。
      </p>
      <p>
        它是一个耳边的英语世界，带你享受被异国语言和文化熏染、启发滋养的过程。
      </p>
      <p>
        它是一个音乐宝库，语言、年代、风格、名望……都无关紧要，唯一在乎的是品质，满足你爱听又挑剔的耳朵。
      </p>
      <p>
        它是观点汇聚的地方，让来自不同国家、不同背景、不同立场的主持人、嘉宾和听众相处、碰撞、分享，开阔彼此的眼界。
      </p>
      <p>它是一个传播者，传播开放乐活的信仰、态度、生活方式。</p>
      <p>
        听轻松调频EZFM，就是听它个性张扬的主张，幽默耍宝、自然温馨、乐活睿智、率性直言，各具风格、脱口成秀。
      </p>
      <p>
        轻松调频EZFM主要面向白领精英、新锐人群和在华外籍受众播出。目前，轻松调频除通过北京FM91.5、网站、手机客户端APP每天24小时播出。
      </p>
      <p>
        本客户端所有内容版权归轻松调频EZFM所有，未经许可不得转载。内容及商务合作，请邮件联系：criezfm@cri.com.cn。
      </p>
      <p>更多轻松调频信息，请登录轻松调频官方网站 www.criezfm.com。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "about",
  data() {
    return {
      msg: "about",
    };
  },
};
</script>


<style scoped lang="scss">
body,
html {
  font-family: "Microsoft YaHei", "\5fae\8f6f\96c5\9ed1", "\5b8b\4f53",
    sans-serif;
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.about {
  background: #f3f4f5;
}
.aboutComcontainer {
  width: 1280px;
  margin: 0 auto;
}
.crumbs {
  padding: 17px 0 27px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #999;
  display: block;
  a {
    color: #999;
  }
}
.about-wrap {
  font-size: 16px;
  line-height: 1.8em;
  padding: 0px 0px 67px 0px;
  margin-top: 30px;
  h3 {
    font-size: 24px;
    color: #333;
  }
  p {
    margin-top: 20px;
    text-indent: 2em;
    text-align: justify;
    color: black;
  }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 900px) {
  *{
       box-sizing: border-box;
  }
  .aboutComcontainer {
    width: 100%;
  }
  .about {
    background: #fff;
  }
  .crumbs {
    display: none;
  }
 
  .about-wrap {
 
    font-size: 16px;
    line-height: 1.8em;
    padding: 30px 2% 130px 2%;
    margin-top: 0px;
    h3 {
      font-size: 24px;
      color: #333;
    }
    p {
      margin-top: 20px;
      text-indent: 2em;
      text-align: justify;
      color: black;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/About.vue